<div class="rn-page">
  <div class="rn-page__section">
    @if (isLoading()) {
      <div class="rn-page--busy">
        <app-spinner [styleRules]="{'transform': 'translateY(250px)'}"></app-spinner>
      </div>
    } @else {
      @for (option of testOptions; track option) {
        <div>
          {{option}}
        </div>
      }
      <div class="form-group" [formGroup]="controlGroupsForm">
        <div class="card panel--left">
          <ul class="control-group-list" formArrayName="groups" name="groups">
            <li>
              <button type="button" class="control-group-button control-group-button--add" (click)="addEmptyGroup()">Add new Group</button>
            </li>
            @for (group of groupsCtl; track group; let i = $index) {
              <li [formGroupName]="i">
                <button type="button" class="control-group-button" [class.control-group-button--selected]="isSelectedGroup(group)" [class.control-group-button--unsaved]="groupHasUnsavedChanges(group)" (click)="switchGroups(group)">{{group.controls.group_name.value || 'New Group *'}}</button>
              </li>
            }
          </ul>
        </div>
        <div class="card panel--right">
          @if (!clientHasGroups()) {
            <p>Please create a new group to get started.</p>
          }
          @if (clientHasGroups()) {
            <ul class="control-group-details-list" formArrayName="groups" name="groups">
              @for (group of groupsCtl; track group; let i = $index) {
                <li [formGroupName]="i">
                  <div class="control-group-details" [class.control-group-details--hidden]="!isSelectedGroup(group)" [class.control-group-details--unsaved]="groupHasUnsavedChanges(group)">
                    <form (submit)="saveGroup($event, group)" (keydown)="preventSubmitOnEnter($event)" [formGroup]="group">
                      <div class="group-name-container" [class.has-error]="(!groupNameIsValid(group) || groupNameIsEmpty(group)) && group.get('group_name').dirty">
                        <label>Group Name</label>
                        <input type="text" class="form-control" name="pending" formControlName="group_name" autocomplete=false/>
                        @if (groupNameIsEmpty(group) && group.get('group_name').dirty) {
                          <p class="error-text">Group name is required</p>
                        }
                        @if (!groupNameIsValid(group)) {
                          <p class="error-text">This Group name has already been used</p>
                        }
                      </div>
                      <!-- Form for adding a tag to a group (new or existing) -->
                      @if (groupTagsFetched(group) || !isSavedGroup(group)) {
                        <rn-new-control-tag-form
                          [allTagNames]="allTagNames"
                          [formGroupRecievingTag]="group"
                          (addTag)="addNewTagEvent($event, group)">
                        </rn-new-control-tag-form>
                      }
                      <label>Tags</label>
                      @if (showNewTagLoading) {
                        <app-spinner></app-spinner>
                      }
                      @if (group.controls['tags']) {
                        <div class="form-group" formArrayName="tags" name="tags">
                          @for (tag of group.controls['tags'].controls; track tag; let j = $index) {
                            <li class="control-group-item" [formGroupName]="j">
                              <rn-control-tag-detail [tag]="tag" [group]="group" (remove)="removeTag(group.controls['tags'], j)"></rn-control-tag-detail>
                            </li>
                          }
                        </div>
                      }
                      <div>
                        @if (showTagLoading(group)) {
                          <app-spinner></app-spinner>
                        }
                        @if (group.controls['tags'] && group.controls['tags'].errors && group.controls['tags'].errors.itemsInArrayAreNotUnique) {
                          <p class="error-text">Tags list contains duplicate tags.</p>
                        }
                        @if (groupTagsFetched(group) && !groupHasTags(group)) {
                          <p class="error-text">Please add at least 1 tag before saving.</p>
                        }
                        <button type="submit" class="btn btn-primary control-group-save-btn">Save Group</button>
                        @if (groupHasUnsavedChanges(group)) {
                          <p class="error-text">This Group Has Unsaved Changes</p>
                        }
                      </div>
                    </form>
                  </div>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    }

  </div>
</div>

<message-dialog #errorMsg [showCancel]="false"></message-dialog>

